import Router from '@components/Router';
import MantineProvider from '@providers/Mantine/MantineProvider';
import PhosphorIconsProvider from '@providers/PhosphorIcons/PhosphorIconsProvider';
import ReactQueryProvider from '@providers/ReactQuery/ReactQueryProvider';
import ThirdPartyServicesProvider from '@providers/ThirdPartyServicesProvider';
import React from 'react';

const App: React.FC<{}> = () => {
    return (
        <ReactQueryProvider>
            <MantineProvider>
                <ThirdPartyServicesProvider enabled={true}>
                    <PhosphorIconsProvider>
                        <Router />
                    </PhosphorIconsProvider>
                </ThirdPartyServicesProvider>
            </MantineProvider>
        </ReactQueryProvider>
    );
};

export default App;
